import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { DesktopSkeleton } from './Desktop/DesktopSkeleton';
import { MobileSkeleton } from './Mobile/MobileSkeleton';
export function ProductCardSkeleton(t0) {
  const $ = _c(2);
  const {
    isSpotlight
  } = t0;
  let t1;
  if ($[0] !== isSpotlight) {
    t1 = <Box data-testid="skeleton-card"><DesktopSkeleton isSpotlight={isSpotlight} /><MobileSkeleton isSpotlight={isSpotlight} /></Box>;
    $[0] = isSpotlight;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}